import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreRangeFormValues, RiskScoreRange } from '../../../types';
import { riskLevelsApi } from '../services';

export interface RiskLevelsFormState {
  formValues?: RiskScoreRangeFormValues;
  settingId?: string;
}

const initialState: RiskLevelsFormState = {};

export const riskLevelsFormSlice = createSlice({
  name: 'riskLevelsForms',
  initialState,
  reducers: {
    clearSettingStateState: (state) => {
      state.formValues = undefined;
      state.settingId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      riskLevelsApi.endpoints.getRiskScoreRange.matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreRange }>) => {
        const { data } = action.payload;

        state.formValues = {
          name: data.name,
          action: data.action,
          rangeStart: data.rangeStart.toString(),
          rangeEnd: data.rangeEnd.toString(),
        };
      },
    );
    builder.addMatcher(
      riskLevelsApi.endpoints.updateRiskScoreRange.matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreRange }>) => {
        const { data } = action.payload;

        state.formValues = {
          name: data.name,
          action: data.action,
          rangeStart: data.rangeStart.toString(),
          rangeEnd: data.rangeEnd.toString(),
        };
      },
    );
  },
});

export const { clearSettingStateState } = riskLevelsFormSlice.actions;

export default riskLevelsFormSlice.reducer;
